import { Outlet } from "react-router-dom";
import { Database } from "lucide-react";
import { AppSidebar } from "@/components/AppSidebar";
import { MobileNavTrigger } from "@/components/MobileTopBar";
import { SidebarProvider } from "@/components/ui/sidebar";
import DatacoreSubNav from "@/components/datacore/DatacoreSubNav";


const DatacoreLayout = () => (
  <SidebarProvider>
    <div className="min-h-dvh flex w-full bg-background">
      <AppSidebar />
      <div className="flex-1 flex flex-col min-w-0 h-dvh overflow-hidden">
        <header className="pt-safe flex shrink-0 items-center gap-2 border-b border-border px-2 py-2 sm:gap-3 sm:px-6 sm:py-3">
          <MobileNavTrigger />
          <div className="flex items-center gap-2.5 min-w-0">
            <Database className="h-5 w-5 text-primary shrink-0" aria-hidden />
            <div className="min-w-0">
              <h1 className="text-base font-semibold leading-tight text-foreground">
                Datacore
              </h1>
              <p className="text-xs text-muted-foreground truncate">
                Data uploads and source integrations for Prism.
              </p>
            </div>
          </div>
        </header>

        <main className="flex-1 overflow-auto p-4 sm:p-6">
          <div className="mx-auto max-w-[1800px]">
            <DatacoreSubNav />
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  </SidebarProvider>
);

export default DatacoreLayout;
